(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else api.mount(root);
})(typeof window === 'undefined' ? undefined : window, function () {
  'use strict';
  const KEY = 'thc.apolloFleetDenied.v2';
  const PATHS = new Set(["/pages/fleets","/pages/fleet-cost-savings","/pages/explore-the-xtractor","/pages/time-to-roi-after-adopting-the-xtractor-hub-cap","/pages/annual-inspection-cost-savings","/pages/damaged-hub-cap-replacement-savings","/pages/vocational-fleet-oil-change-savings","/pages/otr-fleet-annual-hub-oil-change","/pages/wheel-end-contamination-costs-fuel"]);
  function inScope(location) {
    return location.protocol === 'https:' && location.hostname === 'thehubcorp.com' && PATHS.has(location.pathname);
  }
  function permitted(privacy) {
    try {
      const consent = privacy.currentVisitorConsent();
      return consent.analytics === 'yes' && consent.marketing === 'yes' &&
        consent.sale_of_data !== 'no' && privacy.analyticsProcessingAllowed() === true &&
        privacy.marketingAllowed() === true && privacy.saleOfDataAllowed() === true;
    } catch (_) { return false; }
  }
  function createGate(env) {
    let attempted = false;
    let terminal = false;
    let initialized = false;
    let state = 'off';
    function publish(value) { state = value; }
    function locallyAllowed() {
      try { return env.storage.getItem(KEY) !== 'denied'; } catch (_) { return false; }
    }
    function recordDenied() {
      try { env.storage.setItem(KEY, 'denied'); } catch (_) {}
    }
    function clearDenied() {
      try { env.storage.removeItem(KEY); return env.storage.getItem(KEY) !== 'denied'; }
      catch (_) { return false; }
    }
    function stop() {
      if (terminal) return;
      terminal = true;
      recordDenied();
      env.removeScript();
      publish('withdrawn');
      if (attempted) env.reload();
    }
    function evaluate(consentChanged) {
      if (terminal) return;
      const allowed = inScope(env.location) && permitted(env.privacy());
      if (!allowed) {
        if (attempted) stop();
        else publish('off');
        return;
      }
      if (consentChanged === true && !clearDenied()) return;
      if (!locallyAllowed()) {
        if (attempted) stop();
        return;
      }
      if (attempted) return;
      attempted = true;
      publish('loading');
      try {
        env.loadScript(function () {
          if (terminal || !inScope(env.location) || !locallyAllowed() || !permitted(env.privacy())) {
            stop();
            return;
          }
          if (initialized) return;
          initialized = true;
          try { env.initialize(); publish('active'); }
          catch (_) { publish('failed'); }
        }, function () { if (!terminal) publish('failed'); });
      } catch (_) { publish('failed'); }
    }
    return { evaluate, stop, state: () => state };
  }
  function mount(win) {
    if (!win || !inScope(win.location) || win.__thcApolloFleetGate || (win.Shopify && win.Shopify.designMode)) return;
    let script;
    const gate = createGate({
      location: win.location,
      storage: {
        getItem: key => win.localStorage.getItem(key),
        setItem: (key, value) => win.localStorage.setItem(key, value),
        removeItem: key => win.localStorage.removeItem(key)
      },
      privacy: () => win.Shopify && win.Shopify.customerPrivacy,
      loadScript: (loaded, failed) => {
        script = win.document.createElement('script');
        script.src = 'https://assets.apollo.io/micro/website-tracker/tracker.iife.js?nocache=' + Math.random().toString(36).substring(7);
        script.async = true;
        script.defer = true;
        script.onload = loaded;
        script.onerror = failed;
        win.document.head.appendChild(script);
      },
      removeScript: () => { if (script) script.remove(); },
      initialize: () => win.trackingFunctions.onLoad({ appId: '6ac944a39becb8000c6585b6' }),
      reload: () => win.location.reload()
    });
    win.__thcApolloFleetGate = gate;
    win.document.addEventListener('visitorConsentCollected', () => gate.evaluate(true));
    win.addEventListener('storage', event => { if (event.key === KEY || event.key === null) gate.evaluate(); });
    win.addEventListener('popstate', () => gate.evaluate());
    win.addEventListener('pageshow', event => { if (event.persisted) gate.stop(); });
    if (win.Shopify && win.Shopify.customerPrivacy) gate.evaluate();
    else if (win.Shopify && typeof win.Shopify.loadFeatures === 'function') {
      try {
        win.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
          if (!error) gate.evaluate();
        });
      } catch (_) {}
    }
  }
  return { KEY, inScope, permitted, createGate, mount };
});
